import { noop } from 'es-toolkit';
import { createContext } from 'react';
export const ModalQueueContext = createContext({
    queue: [],
    setOpen: noop,
});
